/**
 * Input of a bank form block from the block object: the listed fields of `bank`, a missing value
 * as null (the API keeps an omitted field, only null clears it).
 */
export const toProjectBankInput = (project, fieldNames) => {
  const bank = project.bank ?? {};

  return Object.fromEntries(fieldNames.map((field) => [field, bank[field] ?? null]));
};
